import { Injectable } from '@angular/core';

@Injectable()
export class GroupByService {
    groupBy(collection: Object[], term: string, returnRepeated: boolean) {
        var newValue: any[] = [];

        if (returnRepeated) {
            /*para retornar o group com key value e uma lista com os repetidos*/
            for (let i = 0; i < collection.length; i++) {         
                let termObject = term.split(".");
                let val = this.deepFind(collection[i], termObject[0]);
                let keyVal = this.deepFind(collection[i], term);
                let index = newValue.findIndex( myObj => myObj.key == keyVal);
                if (index >= 0) {
                    newValue[index].items.push(collection[i]);
                } else {
                    newValue.push({key: keyVal, value: val, items: [collection[i]]});
                }
            }
        } else {
            for (let i = 0; i < collection.length; i++) {
                let keyVal = this.deepFind(collection[i], term);
                let index = newValue.findIndex( myObj => this.deepFind(myObj, term) == keyVal);
                if (index === -1) {
                    newValue.push(collection[i]);
                }
            }
        }
        return newValue;
        
    }

    private deepFind(obj: any, path: any) {
        var paths = path.toString().split(/[\.\[\]]/);
        var current = obj;

        for (let i = 0; i < paths.length; ++i) {
            if (paths[i] !== "") {
                if (current[paths[i]] == undefined) {
                    return undefined;
                } else {
                    current = current[paths[i]];
                }
            }
        }
        return current;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/services/group-by.service.ts
 **/